import React from 'react';
import { useSearchParams } from 'react-router-dom';
import styles from '../MapDataModal.module.scss';

function FirstConsentScreen(props: any) {
    const { setShowModal, setCurrentScreen, setImportMetrics, isInvestor } = props;
    const [params, setParams] = useSearchParams();
    return (
        <div className={styles.MainScreen}>
            <div style={{ padding: '1rem 0' }}>
                <h2>Map data for Import</h2>
                <p>
                    Map your imported data in minutes with standard financial statements and
                    organise uploaded data.
                </p>
            </div>
            <div className={styles.ButtonContainer}>
                <button
                    className={isInvestor ? styles.purpleWhiteBtn : styles.WhiteButton}
                    onClick={() => setShowModal({ mapDataModal: false, closeModal: false })}
                >
                    Skip
                </button>
                <button
                    className={isInvestor ? styles.purpleBtn : styles.BlueButton}
                    onClick={() => {
                        params.set('currentScreen', '1');
                        setParams(params);
                        setImportMetrics({ sheetName: '', metricRange: '', dateRange: '' });
                        setCurrentScreen(1);
                    }}
                >
                    Map Data
                </button>
            </div>
        </div>
    );
}

export default FirstConsentScreen;
